import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setPoliteStatusMessage } from 'shared/components/StatusMessages/actions';

const usePoliteStatusMessage = (message) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setPoliteStatusMessage(message));
  }, [dispatch, message]);
};

export default usePoliteStatusMessage;
